var map = {
	"./Akshat Narayan Gupta.jpeg": 126,
	"./Ananya Kumar.jpeg": 127,
	"./Arya Tewary.jpeg": 128,
	"./Barsha Bhattacharya.jpeg": 129,
	"./Gaurav Kumar Singh.jpeg": 130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;